import React, { useState, useEffect } from 'react'
import { decryptString } from '../../../../services/crypto'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import CircularProgress from '@mui/material/CircularProgress'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const LoadingModal = (props) => {
  const [open, setOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(decryptString('isMobile'))

  useEffect(() => {
    setOpen(props.openModal)
  }, [props.openModal])

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      /* disableBackdropClick */
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          // Set 'open' to false, however you would do that with your particular code.
          setOpen(false)
        }
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="logo-dialog">
          <img src="assets/images/logo.png" alt="Logo" className="sidebar-brand-full" height={35} />
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={'span'}>
          {!isMobile && (
            <div className="content-dialog-loading">
              <CircularProgress color="secondary" />
            </div>
          )}
          {isMobile && (
            <div className="content-dialog-loading-mobile">
              <CircularProgress color="secondary" />
            </div>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}

export default LoadingModal
